import { render, staticRenderFns } from "./appointmentCheckTipsDialog.vue?vue&type=template&id=bad946ca&scoped=true"
import script from "./appointmentCheckTipsDialog.vue?vue&type=script&lang=js"
export * from "./appointmentCheckTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./appointmentCheckTipsDialog.vue?vue&type=style&index=0&id=bad946ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad946ca",
  null
  
)

export default component.exports